import React from "react";
import ContentLoader from "react-content-loader";

const MyLoader = ({ width, height, viewBox, children }) => (
  <ContentLoader
    style={{ margin: 0 }}
    speed={2}
    width={width}
    height={height}
    viewBox={viewBox}
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
  >
    {children}
  </ContentLoader>
);

export default MyLoader;
